import PrivateIcon from "@/common/images/icons/private.svg?react";

import "./ticks.scss";

export const PrivateTick = () => {
  return (
    <div className="private rg-tick" title="This thing is private">
      <PrivateIcon />
    </div>
  );
};
